import { render, staticRenderFns } from "./FirstBookSemantics.vue?vue&type=template&id=22b125fe&scoped=true&"
import script from "./FirstBookSemantics.vue?vue&type=script&lang=js&"
export * from "./FirstBookSemantics.vue?vue&type=script&lang=js&"
import style0 from "./FirstBookSemantics.vue?vue&type=style&index=0&id=22b125fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b125fe",
  null
  
)

export default component.exports